module.exports = __webpack_public_path__ + "static/media/vehicle6.fe5fd8a5.svg";